<template>
	<!-- 关于我们 -->
	<div class="about share_center">
		<div class="seat">
			<div class="about_hedaer ">
				<div class="logo_box">
					<div class="logo"></div>
					<div class="qw_logo"></div>
				</div>
				<div class="header_list">
					<ul>
						<li :style="listIndex==index?'color:#FF6600;':''" v-for="(item,index) in list" :key='index' @click="go(item.url)">
							{{item.title}}
						</li>
					</ul>
				</div>
				<div class="header_rig">
					<div class="btn" @click="open()">预约演示</div>
					<!-- <div class="btn btn2" >登录/注册</div> -->
				</div>
			</div>
		</div>
		<!-- 移动端样式 -->
		<option-header class="seat2"></option-header>
		<!-- 移动端样式 end-->
		<div class="banner">
			
		</div>
		<div class="about_opt share_center">
			<div class="about_opt_wrap">
				<ul class="share_list_around animate__animated animate__fadeInUp">
					<li :class="listOptIndex==index?'li2':''" v-for="(item,index) in listOpt" :key='index' @click="change(index)">
						{{item}}
					</li>
				</ul>
			</div>
		</div>
		<!-- 公司介绍 -->
		<div class="company share_Up_down">
			<div class="company_tit animate__animated animate__fadeInUp">
				公司介绍
				<span>COMPANY INTRODUCTION</span>
			</div>
			<ul class="company_list animate__animated animate__fadeInUp">
				<li v-for="(item,index) in companyList" :key='index'>
					<div class="top">
						<div class="pic"></div>
						<div class="title">
							{{item.title}}
						</div>
					</div>
					<div class="content">
						{{item.content}}
					</div>
				</li>
			</ul>
			<div class="company_domain animate__animated animate__fadeInUp">
				<div class="left">
					私域流量运营
				</div>
				<div class="center">
					顺溜私域
				</div>
				<div class="right">
					企业数字化
				</div>
			</div>
		</div>
		<!-- 公司文化 -->
		<div class="culture share_Up_down" ref="culture"  >
			<div v-show="cultureShow" class="title share_center_Up_down animate__animated animate__fadeInUp">
				我们的文化
				<span>
					一个人走得很快，一群人才能走的很远
				</span>
			</div>
			<div ref="cultureList" >
				<ul v-show="cultureListShow" class="culture_list share_list animate__animated animate__fadeInUp">
					<li class="share_Up_down">
						<div class="pic"></div>
						<div class="text">忠于目标</div>
					</li>
					<li class="share_Up_down">
						<div class="pic"></div>
						<div class="text">迎难而上</div>
					</li>
					<li class="share_Up_down">
						<div class="pic"></div>
						<div class="text">合作共赢</div>
					</li>
					<li class="share_Up_down">
						<div class="pic"></div>
						<div class="text">感恩利他</div>
					</li>
				</ul>
			</div>
			<div ref="cultureTitle" style="width: 100%;" >
				<div v-show="cultureTitleShow" class="title title2 share_center_Up_down animate__animated animate__fadeInUp">
					使命愿景
					<span>
						让门店生意更好做
					</span>
				</div>
			</div>
			<div ref="mission" >
				<ul v-show="missionShow" class="mission_list share_list animate__animated animate__fadeInUp">
					<li class="share_Up_down">
						<div class="text"><span></span>目标</div>
						<div class="content">
							<span>服务百万线下门店</span> 
							为门店增加30%的业绩
						</div>
						<div class="pic"></div>
					</li>
					<li class="share_Up_down">
						<div class="text"><span></span>意义</div>
						<div class="content">
							<span>对中心化平台的革命，让 </span>
							门店无需长期为平台付费
						</div>
						<div class="pic"></div>
					</li>
					<li class="share_Up_down">
						<div class="text"><span></span>愿景</div>
						<div class="content">
							<span>构建线下门店私域DA资产</span> 
							帮助商户实现数智化运营
						</div>
						<div class="pic"></div>
					</li>
					<li class="share_Up_down">
						<div class="text"><span></span>使命</div>
						<div class="content">
							让用户“回家”
						</div>
						<div class="pic"></div>
					</li>
				</ul>
			</div>
			
		</div>
		<brand-box></brand-box>
		<my-footer></my-footer>
		<register v-show="registerShow" @change='open'></register>
	</div>
</template>

<script>
	import register from '@/components/register/index.vue'
	import brandBox from '@/components/brandBox/index.vue'
 	import myFooter from '@/components/myFooter/index.vue'
	import optionHeader from '@/components/optionHeader/index.vue'
	export default{
		components:{
			brandBox,
			myFooter,
			register,
			optionHeader
		},
		data() {
			return{
				registerShow:false,
				listOpt:['公司介绍','使命愿景','联系我们'],
				list:[{
						title:'首页',
						url:'/home',
					},{
						title:'产品服务',
						url:'/product',
					},{
						title:'渠道合作',
						url:'/channel',
					},{
						title:'关于我们',
						url:'',
					},
				],
				companyList:[{
						pic:'',
						title:'我们是谁？',
						content:'顺溜科技是专注品牌商户的微信私域营销运营落地及营销云软件一站式解决方案的高新科技企业；'
					},{
						pic:'',
						title:'我们做什么？',
						content:'顺溜科技旨在为线下品牌商户提供基于微信生态的SCRM及私域流量营销运营一站式服务，并帮助本地线下门店搭建MartTech技术基础设施，并构建线下品牌商户的DA资产，加速线下企业数字化转型，帮助线下品牌商户数智化运营，快速帮助客户实现获客、转化、增长 。'
					},{
						pic:'',
						title:'什么是私域流量运营？',
						content:'私域流量运营包含行业营销方案，私域运营SOP落地等服务；一站式营销云包含SCRM(社交营销)、CMS(内容管理)、CDP(客户数据平台)、MA(营销自动化)等产品模块；'
					},
				],
				listIndex:'3',
				listOptIndex:'0',
				cultureShow:false,
				cultureListShow:false,
				cultureTitleShow:false,
				missionShow:false
			}
		},
		mounted() {
			window.addEventListener("scroll", this.handleScroll);
			window.addEventListener("scroll", this.handle);
		},
		methods:{
			open(){
				this.registerShow = !this.registerShow
			},
			// 滚动的位置
			change(index){
				this.listOptIndex = index
				if(index == 0){
					document.documentElement.scrollTop = 224
				}
				if(index == 1){
					document.documentElement.scrollTop = 1680
				}
				if(index == 2){
					document.documentElement.scrollTop = 3400
				}
			},
			go(url){
				if(url != ''){
					document.documentElement.scrollTop = 0
					this.$router.push(url)
				}
			},
			handleScroll () { // 实现当滚动到指定位置，触发动画
				// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
				// this.gdjz('earth', 'earth animated bounceInDown', 50)
				let _this = this
				let refArray = [
					{ref: 'culture', show: 'cultureShow'},
					{ref: 'cultureList', show: 'cultureListShow'},
					{ref: 'cultureTitle', show: 'cultureTitleShow'},
					{ref:'mission',show:'missionShow'}
			      ]
				  // console.log(refArray)
				refArray.forEach((r,i) => {
					_this.gdjz(r.ref, 20, () => {
						_this[r.show] = true
					})
				})
			},
			gdjz(div, offset, callback) {
				let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
				// console.log(dom)
				if(dom){
					var a,b,c,d;
					d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
					a = eval(d + offset)
					b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
					c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
					if( b + c > a ) {
						callback && callback()
					}
				}
			},
			handle () { // 实现当滚动到指定位置，触发动画
				// let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
				// this.gdjz('earth', 'earth animated bounceInDown', 50)
				let _this = this
				let refArray = [
					{ref: 'culture', show: 'cultureShow'},
					{ref: 'cultureList', show: 'cultureListShow'},
					{ref: 'cultureTitle', show: 'cultureTitleShow'},
					{ref:'mission',show:'missionShow'}
			      ]
				  // console.log(refArray)
				refArray.forEach((r,i) => {
					_this.gd(r.ref, 20, () => {
						_this[r.show] = false
					})
				})
			},
			gd(div, offset, callback) {
				let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
				// console.log(dom)
				if(dom){
					var a,b,c,d;
					d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
					a = eval(d + offset)
					b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
					c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
					if( b + c < a ) {
						callback && callback()
					}
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.about{
		width: 100%;
		.seat{
			width: 100%;
			height: 0.6rem;
			display: flex;
			justify-content: center;
			position: -webkit-sticky;
			position: sticky;
			top: 0;
			background-color: #fff;
			z-index: 111;
		}
		.seat2{
			display: none;
		}
		// 头部导航
		.about_hedaer{
			width: 12rem;
			height: 0.6rem;
			display: flex;
			align-items: center;
		
			.logo_box{
				width: 23.41%;
				height: 0.39rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 0.16rem;
				
				.logo{
					width:52.5%;
					height: 0.39rem;
					background: url(../../../public/images/logo.png) no-repeat center center;
					background-size: 1.31rem 0.39rem;
				}
				.qw_logo{
					width: 44%;
					height: 0.25rem;
					background: url(../../../public/images/qwlogo.png) no-repeat center center;
					background-size: 1.21rem 0.25rem;
				}
			}
			.header_list{
				width: 37%;
				// margin-top: 0.12rem;
				margin-left:6.82%;
				
				ul{
					width: 100%;
					height: 0.16rem;
					display: flex;
					justify-content: space-between;
					li{
						height: 0.16rem;
						font-size: 0.16rem;
						
					}
					li:hover{
						color: #FF7300;
					}
				}
				
			}
			.header_rig{
				width: 2rem;
				height: 0.3rem;
				margin-top: 0.04rem;
				margin-left: 7.45%;
				// display: flex;
				// justify-content: space-between;
				
				.btn{
					width: 0.9rem;
					height: 0.3rem;
					border: 0.01rem solid #FF9729;
					border-radius: 0.1rem;
					font-size: 0.12rem;
					text-align: center;
					line-height: 0.3rem;
					float: right;
				}
				.btn2{
					background: #FF9729;
					border-radius: 0.1rem;
					color: #fff;
				}
			}
		}
		// 背景图
		.banner{
			width: 100%;
			height: 5.6rem;
			background: url(../../../public/images/aboutUsBanner.png) no-repeat center center;
			background-size: 100% 5.6rem;
		}
		// 关于我们选项
		.about_opt{
			width: 100%;
			height: 1rem;
			background-color: #fff;
			border-bottom: 0.02rem solid #F9F9F9;
			
			.about_opt_wrap{
				width: 12rem;
				height: 1rem;
				ul{
					width: 12rem;
					height: 1rem;
					.li2{
						font-size: 0.24rem;
						height: 1rem;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #FF7300;
						padding: 0 0.2rem;
						border-bottom: 0.02rem solid #FF7300;
						line-height: 1rem;
					}
					li{
						font-size: 0.24rem;
						height: 1rem;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #666666;
						padding: 0 0.2rem;
						line-height: 1rem;
					}
				}
			}
		}
		.company{
			width: 100%;
			height: 10.93rem;
			background-color: #fff;
			.company_tit{
				font-size: 0.28rem;
				color: #000000;
				margin-top: 0.67rem;
				margin-bottom: 0.6rem;
				span{
					display: none;
				}
			}
			.company_list{
				width: 12rem;
				li{
					width: 12rem;
					min-height: 0.6rem;
					.top{
						display: flex;
						.pic{
							width: 0.4rem;
							height: 0.4rem;
							background: linear-gradient(-90deg, #FF7300, #FF9729);
							border-radius: 50%;
						}
						.title{
							font-size: 0.28rem;
							color: #000000;
							line-height: 0.4rem;
							margin-left: 0.2rem;
						}
					}
					.content{
						border-left: 0.01rem dashed #E6D8CA;
						padding-bottom: 0.33rem;
						margin-left: 0.19rem;
						font-size: 0.22rem;
						color: #999999;
						line-height: 0.36rem;
						padding-left: 0.39rem;
						padding-top: 0.14rem;
						margin-top: 0.05rem;
						margin-bottom: 0.06rem;
					}
				}
				li:last-child{
					.content{
						border-left: none;
					}
				}
			}
			.company_domain{
				margin-top: 1.42rem;
				width: 6.63rem;
				height: 2.24rem;
				position: relative;
				.left{
					font-size: 0.28rem;
					color: #F9F9F9;
					width: 3.79rem;
					height: 2.24rem;
					background: linear-gradient(-90deg, #FF7300, #FF9729);
					opacity: 0.8;
					border-radius: 1.12rem;
					line-height: 2.24rem ;
					text-align: center;
					position: absolute;
					z-index: 1;
					left: 0;
				}
				.center{
					width: 0.3rem;
					font-size: 0.28rem;
					color: #F9F9F9;
					position: absolute;
					left: 0;
					right: 0;
					top: 0.5rem;
					bottom: 0;
					margin:0 auto;
					z-index: 11;
					height: 100%;
				}
				.right{
					font-size: 0.28rem;
					color: #F9F9F9;
					width: 3.79rem;
					height: 2.24rem;
					background: linear-gradient(180deg, #88CEFF, #4A9CFF);
					opacity: 0.8;
					border-radius: 1.12rem;
					line-height: 2.24rem ;
					text-align: center;
					position: absolute;
					right: 0;
				}
			}
		}
		.culture{
			width: 100%;
			height: 12.61rem;
			background: url(../../../public/images/about1.png) no-repeat center center;
			background-size: 100% 12.61rem;
			
			.title{
				height: 0.63rem;
				margin-top: 0.7rem;
				font-size: 0.28rem;
				color: #000000;
				span{
					font-size: 0.18rem;
					color: #999999;
				}
			}
			.culture_list{
				width: 12rem;
				height: 3rem;
				margin-top: 0.79rem;
				margin-bottom: 0.3rem;
				li:nth-child(2){
					.pic{
						background: url(../../../public/images/aboutUs1-2.png);
						background-size: 0.9rem  0.9rem;
					}
					
				}
				li:nth-child(3){
					.pic{
						background: url(../../../public/images/aboutUs1-3.png);
						background-size: 0.9rem  0.9rem;
					}
				}
				li:nth-child(4){
					.pic{
						background: url(../../../public/images/aboutUs1-4.png);
						background-size: 0.9rem  0.9rem;
					}
				}
				li{
					width: 2.7rem;
					height: 3rem;
					background: rgba(255, 255, 255, 0.71);
					box-shadow: 0px 0px 1.2rem 0px rgba(51, 51, 51, 0.05);
					border-radius: 0.2rem;
					
					.pic{
						width: 0.9rem;
						height: 0.9rem;
						background: #FFFFFF;
						box-shadow: 0px 0.03rem 0.18rem 0px rgba(4, 0, 0, 0.06);
						border-radius: 50%;
						margin-top: 0.5rem;
						margin-bottom: 0.54rem;
						background: url(../../../public/images/aboutUs1-1.png);
						background-size: 0.9rem  0.9rem;
					}
					.text{
						font-size: 0.22rem;
						color: #010101;
					}
				}
			}
			.mission_list{
				width: 12rem;
				height: 3.4rem;
				margin-top: 0.8rem;
				li{
					width: 2.7rem;
					height: 3.4rem;
					background: rgba(255, 255, 255, 0.71);
					box-shadow: 0px 0px 1.2rem 0px rgba(51, 51, 51, 0.05);
					border-radius: 0.2rem;

					.text{
						font-size: 0.24rem;
						color: #333;
						margin-top: 0.27rem;
						width: 2.25rem;
						font-weight: bold;
						
						span{
							display: inline-block;
							width: 4px;
							height: 12px;
							background: linear-gradient(-90deg, #FF7300, #FF9729);
							border-radius: 3px;
							margin-right: 6px;
						}
					}
					.content{
						width: 2.25rem;
						height: 0.6rem;
						font-size: 0.2rem;
						color: #8d8d8d;
						line-height: 0.26rem;
						margin-top: 0.27rem;
						span{
							width: 2.35rem;
							display: inline-block;
						}
					}
					.pic{
						width: 1.4rem;
						height: 1.4rem;
						margin-top: 0.23rem;
						background: url(../../../public/images/aboutUs2-1.png);
						background-size:1.4rem 1.4rem;
					}
				}
				li:nth-child(2){
					.pic{
						background: url(../../../public/images/aboutUs2-2.png);
						background-size:1.4rem 1.4rem;
					}
				}
				li:nth-child(3){
					.pic{
						background: url(../../../public/images/aboutUs2-3.png);
						background-size:1.4rem 1.4rem;
					}
				}
				li:nth-child(4){
					.pic{
						background: url(../../../public/images/aboutUs2-4.png);
						background-size:1.4rem 1.4rem;
					}
				}
			}
		}
	}
	// 移动端样式
	@media (max-width:1026px){
		.about{
			width: 100%;
			.seat{
				display: none;
			}
			.seat2{
				display: block;
			}
		
			// 背景图
			.banner{
				width: 100%;
				height: 2.9rem;
				background: url(../../../public/images/aboutUsBanner.png) no-repeat center center;
				background-size: 100% 2.9rem;
			}
			// 关于我们选项
			.about_opt{
				width: 100%;
				height: 1rem;
				background-color: #fff;
				border-bottom: 0.02rem solid #F9F9F9;
				display: none;
			}
			.company{
				width: 100%;
				height: 11.3rem;
				background-color: #fff;
				.company_tit{
					font-size: 0.32rem;
					color: #000000;
					margin-top: 0.49rem;
					margin-bottom: 0.5rem;
					color: #000000;
					display: flex;
					flex-direction: column;
					align-items: center;
					span{
						display: block;
						font-size: 0.24rem;
						color: #999999;
						margin-top: 0.21rem;
					}
				}
				.company_list{
					width: 6.79rem;
					li{
						width: 6.79rem;
						min-height: 0.6rem;
						.top{
							display: flex;
							.pic{
								width: 0.4rem;
								height: 0.4rem;
								background: linear-gradient(-90deg, #FF7300, #FF9729);
								border-radius: 50%;
							}
							.title{
								font-size: 0.28rem;
								color: #000000;
								line-height: 0.4rem;
								margin-left: 0.2rem;
							}
						}
						.content{
							border-left: 0.01rem dashed #E6D8CA;
							padding-bottom: 0.33rem;
							margin-left: 0.19rem;
							font-size: 0.22rem;
							color: #999999;
							line-height: 0.36rem;
							padding-left: 0.39rem;
							padding-top: 0.14rem;
							margin-top: 0.05rem;
							margin-bottom: 0.06rem;
						}
					}
					li:last-child{
						.content{
							border-left: none;
						}
					}
				}
				.company_domain{
					margin-top: 0.79rem;
					width: 6.63rem;
					height: 2.24rem;
					position: relative;
					.left{
						font-size: 0.28rem;
						color: #F9F9F9;
						width: 3.79rem;
						height: 2.24rem;
						background: linear-gradient(-90deg, #FF7300, #FF9729);
						opacity: 0.8;
						border-radius: 1.12rem;
						line-height: 2.24rem ;
						text-align: center;
						position: absolute;
						z-index: 1;
						left: 0;
					}
					.center{
						width: 0.3rem;
						font-size: 0.28rem;
						color: #F9F9F9;
						position: absolute;
						left: 0;
						right: 0;
						top: 0.5rem;
						bottom: 0;
						margin:0 auto;
						z-index: 11;
						height: 100%;
					}
					.right{
						font-size: 0.28rem;
						color: #F9F9F9;
						width: 3.79rem;
						height: 2.24rem;
						background: linear-gradient(180deg, #88CEFF, #4A9CFF);
						opacity: 0.8;
						border-radius: 1.12rem;
						line-height: 2.24rem ;
						text-align: center;
						position: absolute;
						right: 0;
					}
				}
			}
			.culture{
				width: 100%;
				height: 15rem;
				background:#FAF9F7 ;
				background-size: 100% 12.61rem;
				
				.title{
					width: 100%;
					padding-top: 1rem;
					padding-bottom: 0.59rem;
					height: 0.63rem;
					margin-top: 0rem;
					font-size: 0.32rem;
					color: #000000;
					background:#fff;
					span{
						font-size: 0.24rem;
						color: #999999;
						margin-top: 0.19rem;
					}
				}
				.title2{
					background-color: #F8F7F5;
					padding-top: 0.3rem;
					padding-bottom: 0.5rem;
				}
				.culture_list{
					width: 6.9rem;
					height: 3.4rem;
					margin-top: 0.3rem;
					margin-bottom: 0.3rem;
					display: flex;
					flex-wrap: wrap;
					li{
						width: 3.4rem;
						height: 1.6rem;
						background: rgba(255, 255, 255, 0.71);
						box-shadow: 0px 0px 1.2rem 0px rgba(51, 51, 51, 0.05);
						border-radius: 0.2rem;
						display: flex;
						flex-direction: row;
						
						.pic{
							width: 0.9rem;
							height: 0.9rem;
							background: #FFFFFF;
							box-shadow: 0px 0.03rem 0.18rem 0px rgba(4, 0, 0, 0.06);
							border-radius: 50%;
							margin-top: 0.5rem;
							margin-bottom: 0.54rem;
							margin-left: 0.42rem;
							margin-right: 0.29rem;
							background: url(../../../public/images/aboutUs1-1.png)no-repeat center center;
							background-size: 0.9rem  0.9rem;
						}
						.text{
							font-size: 0.29rem;
							color: #010101;
						}
					}
				}
				.mission_list{
					width: 6.9rem;
					height: 6.62rem;
					margin-top: 0.2rem;
					display: flex;
					flex-wrap: wrap;
					li{
						width: 3.4rem;
						height: 3.2rem;
						background: rgba(255, 255, 255, 0.71);
						box-shadow: 0px 0px 1.2rem 0px rgba(51, 51, 51, 0.05);
						border-radius: 0.2rem;
		
						.text{
							min-width: 2.8rem;
							font-size: 0.24rem;
							color: #999999;
							margin-top: 0.27rem;
							// width: 2.25rem;
						}
						.content{
							min-width: 2.8rem;
							height: 0.6rem;
							font-size: 0.2rem;
							color: #666666;
							line-height: 0.36rem;
							margin-top: 0.27rem;
							span{
								min-width: 2.8rem;
								display: inline-block;
							}
						}
						.pic{
							width: 1.4rem;
							height: 1.4rem;
							margin-top: 0.23rem;
						}
					}
				}
			}
		}
	}
</style>
